import { consentCategories, IOneTrustWeb, OneTrustConfigWeb, OneTrustConsent } from '../types';

export class OneTrustWeb implements IOneTrustWeb {
    async init(config?: OneTrustConfigWeb) {
        if (!config?.enabled || !config.scriptUrl || !config.domainScript) return;

        this.loadOneTrustScript(config.scriptUrl, config.domainScript);
    }

    /* eslint-disable class-methods-use-this */
    showPreferenceModal() {
        if (typeof window.OneTrust?.ToggleInfoDisplay === 'function')
            window.OneTrust.ToggleInfoDisplay();
    }

    /* eslint-disable class-methods-use-this */
    loadOneTrustScript = (url: string, domainScript: string) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.setAttribute('data-domain-script', domainScript);
        document.head.appendChild(script);

        // OptanonWrapper function reserved by SDK and used after initialize
        const callback = document.createElement('script');
        callback.type = 'text/javascript';
        callback.text = `function OptanonWrapper() {
        const otConsentSdk = document.getElementById("ot-sdk-btn-floating");
        if (otConsentSdk) {
            otConsentSdk.style.display = "none";
        }
    }`;
        document.body.appendChild(callback);
    };

    getConsentStatus = async (): Promise<OneTrustConsent> => {
        const activeCategories = `,${window.OnetrustActiveGroups},`;
        const personalAds = consentCategories.some((categoryId) =>
            activeCategories.includes(categoryId)
        );
        let tcfConsentString: string | null = null;
        let gppConsentString = '';
        let gppSectionId = '';
        const usLocation =
            typeof window.OneTrust?.getGeolocationData === 'function'
                ? window.OneTrust?.getGeolocationData()?.country === 'US'
                : false;

        window.OneTrust?.getVendorConsentsRequestV2?.((e) => {
            tcfConsentString = e?.tcString || null;
            gppConsentString = usLocation ? e?.gppString || '' : '';
            gppSectionId = usLocation ? e?.gppSid || '' : '';
        });

        return {
            doNotTrack: !personalAds,
            limitAdvertisementTracking: !personalAds,
            tcfConsentString,
            gppConsentString,
            gppSectionId,
        };
    };
}
